import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';



const json = {
    1: { // Exercise num
        unit: 'Unit 2',
        id: 'SB5-V2-U2-P15-E1',
        audio: 'img/FriendsPlus/Page14/Audio/audio-e2-p14.mp3',
        video: 'Videos/e2.p14.mp4',
        recorder: true,
        component: UI,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page15/E2/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page14/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page14/Audio/hinh1-e2-p14.mp3' },
                { url: 'img/FriendsPlus/Page14/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page14/Audio/hinh2-e2-p14.mp3' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page14/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page14/Audio/hinh3-e2-p14.mp3' },
                { url: 'img/FriendsPlus/Page14/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page14/Audio/hinh4-e2-p14.mp3' },
            ],

        ],
    },
    2: { // Exercise num
        unit: 'Unit 2',
        id: 'SB5-V2-U2-P15-E2',
        audio: 'img/FriendsPlus/Page15/Audio/audio-e2-p15.mp3',
        video: '',
        recorder: true,
        component: UI,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page15/E2/1a.jpg' },
                { url: 'img/FriendsPlus/Page15/E2/1b.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/tieude-e2-p15.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/1c.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page15/E2/2.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page15/E2/3.jpg' },
                { url: 'img/FriendsPlus/Page15/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau1.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau2.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/6.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page15/E2/7.jpg' },
                { url: 'img/FriendsPlus/Page15/E2/8.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau3.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/9.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau4.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/10.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page15/E2/11.jpg' },
                { url: 'img/FriendsPlus/Page15/E2/12.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau5.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/13.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau6.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/14.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page15/E2/15.jpg' },
                { url: 'img/FriendsPlus/Page15/E2/16.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau7.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/17.jpg', audioUrl: 'img/FriendsPlus/Page15/Audio/cau8.mp3' },
                { url: 'img/FriendsPlus/Page15/E2/18.jpg' },
            ],
            [
                // Column7
                { url: 'img/FriendsPlus/Page15/E2/19.jpg' },
            ],

        ],
    },

    3: { // Exercise num
        unit: 'Unit 2',
        id: 'SB5-V2-U2-P15-E3',
        audio: '',
        video: '',
        component: DesignUnderLine,
        exerciseKey: 'img/FriendsPlus/Page15/E3/Key/answerKey.png',
        totalInput: 3,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page15/E3/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page15/E3/2.jpg' },
                { url: 'img/FriendsPlus/Page15/E3/3.jpg', input: 1, },
                { url: 'img/FriendsPlus/Page15/E3/4.jpg', input: 1, isCorrect: true },
                { url: 'img/FriendsPlus/Page15/E3/5.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page15/E3/6.jpg' },
                { url: 'img/FriendsPlus/Page15/E3/7.jpg', input: 2, isCorrect: true },
                { url: 'img/FriendsPlus/Page15/E3/8.jpg', input: 2, },
                { url: 'img/FriendsPlus/Page15/E3/9.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page15/E3/10.jpg' },
                { url: 'img/FriendsPlus/Page15/E3/11.jpg', input: 3, isCorrect: true },
                { url: 'img/FriendsPlus/Page15/E3/12.jpg', input: 3, },
                { url: 'img/FriendsPlus/Page15/E3/13.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page15/E3/14.jpg' },
            ],

        ],
    },

    4: { // Exercise num
        unit: 'Unit 2',
        id: 'SB5-V2-U2-P15-E4',
        audio: '',
        video: '',
        // fontSize: 20,
        component: D1,
        exerciseKey: 'img/FriendsPlus/Page15/E4/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page15/E4/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page15/E4/2.jpg' },
                { url: 'img/FriendsPlus/Page15/E4/3.jpg', input: true, answer: "don't like" },
                { url: 'img/FriendsPlus/Page15/E4/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page15/E4/5.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page15/E4/6.jpg' },
                { url: 'img/FriendsPlus/Page15/E4/7.jpg', input: true, answer: "doesn't like" },
                { url: 'img/FriendsPlus/Page15/E4/8.jpg' },
                { url: 'img/FriendsPlus/Page15/E4/9.jpg', input: true, answer: "likes" },
                { url: 'img/FriendsPlus/Page15/E4/10.jpg' },
            ],


        ],
    },

    5: { // Exercise num
        unit: 'Unit 2',
        id: 'SB5-V2-U2-P15-E5',
        audio: '',
        video: '',
        recorder: true,
        component: UI,
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page15/E5/1.jpg' },
            ],
        ],
    },


}

export default json;